import React from 'react'
import moment from 'moment'

// components
import {
  CRow
} from '@coreui/react-pro'
import AppTextColumnDetails from '../general-details/AppTextColumnDetails'

const AppDetails = ({
  companyTimeOffDetails,
}) => {
  return (
    <>
      <CRow className='mb-4'>
        <AppTextColumnDetails
          colSize="6"
          title="Time-Off Name"
          subtitle={companyTimeOffDetails?.name}
        />
        <AppTextColumnDetails
          colSize="6"
          title="Time-Off Type"
          subtitle={companyTimeOffDetails?.type}
        />
      </CRow>
      <CRow className='mb-4'>
        <AppTextColumnDetails
          colSize="6"
          title="Start Date"
          subtitle={moment(companyTimeOffDetails?.start_date).format('DD/MM/YYYY')}
        />
        <AppTextColumnDetails
          colSize="6"
          title="End Date"
          subtitle={moment(companyTimeOffDetails?.end_date).format('DD/MM/YYYY')}
        />

      </CRow>
      <CRow>
        <AppTextColumnDetails
          colSize="6"
          title="Duration"
          subtitle={companyTimeOffDetails?.duration ? `${companyTimeOffDetails?.duration} Days` : '-'}
        />
        <AppTextColumnDetails
          colSize="6"
          title="Additional Notes"
          subtitle={companyTimeOffDetails?.additional_notes || '-'}
        />
      </CRow>
    </>
  )
}

export default AppDetails
